import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { injectIntl } from 'react-intl';
import intlShape from '@/shared/utils/intlShape';
import messages from './trainingMessages';

const TrainingEndDateIcon = ({ intl, id, endDate }) => {
  if (!endDate) return null;

  const end = moment.utc(endDate).startOf('day');
  const today = moment.utc().startOf('day');
  const daysUntilEndDate = end.diff(today, 'days');

  if (daysUntilEndDate < 0) {
    return (
      <OverlayTrigger
        placement="top"
        overlay={
          <Tooltip id={`training-enddate-passed${id || ''}`}>
            {intl.formatMessage(messages.EndDatePassed)}
          </Tooltip>
        }
      >
        <i className="fa fa-exclamation-triangle fa-fw text-danger" />
      </OverlayTrigger>
    );
  }

  if (daysUntilEndDate <= 14) {
    return (
      <OverlayTrigger
        placement="top"
        overlay={
          <Tooltip id={`training-enddate-warning${id || ''}`}>
            {intl.formatMessage(messages.EndDateApproaching)}
          </Tooltip>
        }
      >
        <i className="fa fa-exclamation-triangle fa-fw text-warning" />
      </OverlayTrigger>
    );
  }

  return null;
};

TrainingEndDateIcon.propTypes = {
  intl: intlShape.isRequired,
  id: PropTypes.string,
  endDate: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
};

TrainingEndDateIcon.defaultProps = {
  id: undefined,
  endDate: undefined,
};

export default injectIntl(TrainingEndDateIcon);
